import { LineLayer } from '@deck.gl/layers';
import { DataSet } from '@deck.gl/core/lib/layer';
import { RGBAColor } from 'deck.gl';

const groundColor = { red: 0, green: 255, blue: 255 };
const cruiseColor = { red: 0, green: 128, blue: 0 };

const getColor = (data: any): RGBAColor => {
  const altitudeInFeet = data[1][2];
  // scale is a 0 -> 1 float.
  const scale = Math.min(1, altitudeInFeet / 10000);

  const red = groundColor.red + scale * (cruiseColor.red - groundColor.red);
  const green = groundColor.green + scale * (cruiseColor.green - groundColor.green);
  const blue = groundColor.blue + scale * (cruiseColor.blue - groundColor.green);
  const alpha = 128 * (1 - scale / 1.5);

  return [red, green, blue, alpha];
};

export const flightLayer = (data: DataSet<any>, strokeWidth: number = 3) => {
  return new LineLayer({
    id: 'flight-layer',
    data: data,
    // fp64: false,
    getSourcePosition: d => d[1],
    getTargetPosition: d => d[2],
    getColor,
    getWidth: () => strokeWidth,
    pickable: true,
    // pickable: Boolean(this.props.onHover),
    // onHover: this.props.onHover,
  });
};
